<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<pid-art-footer
  [country]="country"
  [locale]="locale"
  [environment]="footerEnvironment"
  [showLanguageChooser]="false"
/>
